module.exports = __webpack_public_path__ + "img/calendar.778b2b01.svg";